import { LiveEventStatusInformation, LiveEventsStatuses, YammerState } from '../../state/types';

type FindLiveEventStatusByBroadcastIdThrows = (
  state: YammerState,
  broadcastId: LiveEventStatusInformation['broadcastId']
) => LiveEventStatusInformation;
export const findLiveEventStatusByBroadcastIdThrows: FindLiveEventStatusByBroadcastIdThrows = (state, broadcastId) => {
  const liveEventStatus = state.liveEventsStatuses[broadcastId];
  if (!liveEventStatus) {
    throw new Error('Can not find live event status in the store');
  }

  return liveEventStatus;
};

type FindLiveEventStatusByBroadcastId = (
  state: YammerState,
  broadcastId: LiveEventStatusInformation['broadcastId']
) => LiveEventStatusInformation | undefined;
export const findLiveEventStatusByBroadcastId: FindLiveEventStatusByBroadcastId = (state, broadcastId) =>
  state.liveEventsStatuses[broadcastId];

type GetLiveEventsStatuses = (state: YammerState) => LiveEventsStatuses;
export const getLiveEventsStatuses: GetLiveEventsStatuses = (state) => state.liveEventsStatuses;

type GetGroupIdThrows = (
  state: YammerState,
  broadcastId: LiveEventStatusInformation['broadcastId']
) => LiveEventStatusInformation['groupId'];
export const getGroupIdThrows: GetGroupIdThrows = (state, broadcastId) =>
  findLiveEventStatusByBroadcastIdThrows(state, broadcastId).groupId;
